import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";

import { section } from "@/glow";
import { listen, qsa, qs } from "@fluorescent/dom";
import { animateCollapsibleRowList, shouldAnimate } from "@/lib/animation";

const selectors = {
  itemTrigger: ".collapsible-row-list-item__trigger",
  header: "[data-section-type='header']",
};

section("collapsible-row-list", {
  onLoad() {
    this.items = qsa(selectors.itemTrigger, this.container);
    this.header = qs(selectors.header, document);

    this.isStickyHeader = this.header.dataset.enableStickyHeader === "true";
    this.shouldAutoCollapse = this.container.dataset.autoCollapse === "true";

    this.clickHandlers = listen(this.items, "click", e => {
      e.preventDefault();
      const { parentNode: group, nextElementSibling: content } =
        e.currentTarget;

      if (content && isVisible(content)) {
        this._close(e.currentTarget, group, content);
      } else {
        this._open(e.currentTarget, group, content);
      }
    });

    if (shouldAnimate(this.container)) {
      this.animateCollapsibleRowList = animateCollapsibleRowList(
        this.container
      );
    }
  },

  _closeOpenGroups(currentGroup) {
    for (const label of this.items) {
      const group = label.parentNode;
      if (group === currentGroup) continue;

      const content = label.nextElementSibling;
      if (content && isVisible(content)) {
        this._toggle(label, group, content, "up", false);
      }
    }
  },

  _open(label, group, content) {
    if (!content) return;

    if (this.shouldAutoCollapse) {
      this._closeOpenGroups(group);

      setTimeout(() => {
        if (this._isInView(label) === false) {
          label.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
        }
      }, 200);
    }

    this._toggle(label, group, content, "down", true);
  },

  _close(label, group, content) {
    if (!content) return;

    this._toggle(label, group, content, "up", false);
  },

  _isInView(element) {
    let headerHeight = 0;

    if (this.isStickyHeader) {
      headerHeight = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue("--header-desktop-sticky-height")
          .replace(/px/gi, "")
      );
    }
    const rect = element.getBoundingClientRect();

    return rect.top >= headerHeight && rect.bottom <= window.innerHeight;
  },

  _toggle(label, group, content, direction, isOpen) {
    slideStop(content);
    direction === "down" ? slideDown(content) : slideUp(content);

    group.setAttribute("data-open", isOpen);
    label.setAttribute("aria-expanded", isOpen);
    content.setAttribute("aria-hidden", !isOpen);
  },

  onBlockSelect({ target }) {
    const label = qs(selectors.itemTrigger, target);
    const { parentNode: group, nextElementSibling: content } = label;

    this._open(label, group, content);
  },

  onUnload() {
    this.clickHandlers();
    this.animateCollapsibleRowList?.destroy();
  },
});
